import { render, staticRenderFns } from "./FieldsetTextParts.vue?vue&type=template&id=bc032756&scoped=true"
import script from "./FieldsetTextParts.vue?vue&type=script&lang=ts"
export * from "./FieldsetTextParts.vue?vue&type=script&lang=ts"
import style0 from "./FieldsetTextParts.vue?vue&type=style&index=0&id=bc032756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc032756",
  null
  
)

export default component.exports